import { render, staticRenderFns } from "./ReviewsPage.vue?vue&type=template&id=6951cd6d&"
import script from "./ReviewsPage.vue?vue&type=script&lang=js&"
export * from "./ReviewsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports